import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserInfoService } from '../service/user-info.service';
import * as UserInfoActions from './user-info.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class UserInfoEffects {
  private actions$ = inject(Actions);
  private userInfoService = inject(UserInfoService);

  getUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInfoActions.loadUserInfo),
      switchMap((action) => {
        return this.userInfoService.getUserInfo(action.language).pipe(
          map((_response) => UserInfoActions.loadUserInfoSuccess({ userInfo: _response })),
          catchError((error) => of(UserInfoActions.loadUserInfoFailure({ error })))
        );
      })
    )
  );

  deleteLastViewedDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInfoActions.deleteLastViewedDocument),
      switchMap(({ documentId }) =>
        this.userInfoService.deleteLastViewedDocument(documentId).pipe(
          map((response) => UserInfoActions.deleteLastViewedDocumentSuccess({ response })),
          catchError((error) =>
            of(UserInfoActions.deleteLastViewedDocumentFailure({ error: { ...error, documentId } }))
          )
        )
      )
    )
  );
}
